import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { search } from '../../actions/search';
import SearchBar from '../SearchBar';
import Link from '../Link';
import AutosuggestDropdownItem from '../AutosuggestDropdownItem';
import styles from './HomeSearchBar.style';
import AutosuggestContractItem from '../AutosuggestContractItem';

const HomeSearchBar = ({ className, ...other }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const suggestions = useSelector(state => get(state, 'search.results'));
  const partnerSuggestions = get(suggestions, 'partners', [])
    .map(partner => ({
      icon: 'People',
      value: partner.partnerAddress,
      label: partner.name,
      href: `/partners/${partner.partnerAddress}`,
    }))
    .slice(0, 2);
  const contractSuggestions = get(suggestions, 'contracts', [])
    .map(contract => ({
      approvalStatus: contract.approvalStatus,
      value: contract.address,
      label: contract.name,
      secondaryLabel: contract.contractId,
      tertiaryLabel: get(contract, 'partner.name'),
      href: `/contracts/${contract.address}`,
      contract,
    }))
    .slice(0, 2);

  const handleChange = async newInput => {
    setInput(newInput);
    if (!newInput) return;
    setIsLoading(true);
    await dispatch(search(['partners', 'contracts'], newInput));
    setIsLoading(false);
  };

  const Section = ({ list, loading, header }) => (
    <Stack key={list.key}>
      {list.length ? (
        <Stack>
          {header && (
            <Text block className={styles.title}>
              {header}
            </Text>
          )}

          {header === 'Partners' &&
            list.map(props => AutosuggestDropdownItem({ ...props, history }))}

          {header === 'Contracts' && list.map(props => AutosuggestContractItem({ ...props }))}

          <Stack>
            <Link className={styles.moreResults} href={`/${header.toLowerCase()}?q=${input}`}>
              View more results for <strong>{header.toLowerCase()}</strong>
            </Link>
          </Stack>
        </Stack>
      ) : (
        <Stack>
          {loading ? (
            <></>
          ) : (
            <Stack>
              <Text block className={styles.title}>
                No results
              </Text>
              <Link className={styles.moreResults} href={`/${header.toLowerCase()}`}>
                View all <strong>{header.toLowerCase()}</strong>
              </Link>
            </Stack>
          )}
        </Stack>
      )}
    </Stack>
  );

  Section.propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    loading: PropTypes.bool.isRequired,
    header: PropTypes.string.isRequired,
  };

  const Dropdown = () => (
    <Stack className={styles.root}>
      <Section list={partnerSuggestions} loading={isLoading} header="Partners" />
      <Section list={contractSuggestions} loading={isLoading} header="Contracts" />
    </Stack>
  );

  return (
    <SearchBar
      placeholder="Search partners or contracts"
      onChange={handleChange}
      onRenderDropdown={Dropdown}
      isLoading={isLoading}
      className={className}
      suggestions={[]}
      {...other}
    />
  );
};

HomeSearchBar.propTypes = {
  className: PropTypes.string,
};

HomeSearchBar.defaultProps = {
  className: '',
};

export default HomeSearchBar;
